export const checkedSession = (state: any) => state.sessionCheck.checkedSession;
